<template>
  <div class="table-responsive">
    <table>
      <thead class="thead-gray">
        <tr class="text-center">
          <th scope="col" class="text-uppercase" v-for="(item, index) in dataHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row">
          <td
            v-for="(item, index) in dataRow[0] ? dataRow[0] : []"
            :key="index"
            :class="{ 'text-right': index === (dataRow[0] ? dataRow[0] : []).length - 1 }"
          >
            {{ item }}
          </td>
        </tr>
        <tr class="table-row">
          <td rowspan="3">{{ dataRow[1][0] ? dataRow[1][0] : '' }}</td>
          <td>{{ dataRow[1][1] ? dataRow[1][1] : '' }}</td>
          <td class="text-right">{{ dataRow[1][2] ? dataRow[1][2] : '' }}</td>
        </tr>
        <tr class="table-row">
          <td rowspan="2">{{ dataRow[2][1] ? dataRow[2][1] : '' }}</td>
          <td class="text-right">{{ dataRow[2][2] ? dataRow[2][2] : '' }}</td>
        </tr>
        <tr class="table-row">
          <td class="text-right">{{ dataRow[3][2] ? dataRow[3][2] : '' }}</td>
        </tr>
        <tr class="table-row">
          <td
            v-for="(item, index) in dataRow[4] ? dataRow[4] : []"
            :key="index"
            :class="{ 'text-right': index === (dataRow[4] ? dataRow[4] : []).length - 1 }"
          >
            {{ item }}
          </td>
        </tr>

        <tr
          class="table-row"
          v-for="(itemRow, index) in dataRow.filter((e, i) => i > 4)"
          :key="index"
        >
          <td
            v-for="(item, indexcol) in itemRow"
            :key="indexcol"
            :class="{ 'text-right': indexcol === itemRow.length - 1 }"
          >
            {{ item }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      dataTable: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dataHead: [],
        dataRow: [],
      }
    },
    mounted() {
      this.dataHead = this.dataTable.column
      this.dataRow = this.dataTable.rows
    },
  }
</script>

<style scoped></style>
